import listaDDDBrasil from '@/assets/json/lista-ddd-brasil.json';

export default class Cellphone {
  errorMessage = 'Informe seu número de celular com DDD.'
  placeholder = '(DD) 0000-0000'
  mask = '(##)#####-####'

  numberRepeat = 4
  blackList = [
    '(99)99999-9999',
    '(88)88888-8888',
    '(77)77777-7777',
    '(66)66666-6666',
    '(55)55555-5555',
    '(44)44444-4444',
    '(33)33333-3333',
    '(22)22222-2222',
    '(11)11111-1111',
    '(00)00000-0000'
  ]

  removeCharacter = (value) => value.replace(/\D/g, '')
  quantityNumberRepeat = (value) => new Set(value).size < this.numberRepeat
  hasBlackList = (value) => this.blackList.includes(value)
  validNumberCellphone = (value) => /(\([1-9]{2}\))9(\d{4}\-\d{4})/.test(value)
  lengthMask = (value) => value.trim().length === 14

  setMessageError(value) {
    this.errorMessage = this.lengthMask(value) ? 'Número de celular inválido.' : 'Informe seu número de celular com DDD.'
  }

  rulesValidCellphone(value) {
    const noCharacter = this.removeCharacter(value)
    const ddd = noCharacter.toString().substr(0, 2);

    if (!listaDDDBrasil.includes(ddd)) {
      return false;
    }

    const numberRepeat = this.quantityNumberRepeat(noCharacter)

    return !numberRepeat && !this.hasBlackList(value) && this.validNumberCellphone(value.replaceAll(' ', ''))
  }

  valid(value) {
    return this.rulesValidCellphone(value)
  }

  error(value) {
    if (value !== '') {
      this.setMessageError(value)
      return !this.valid(value)
    }
    return this.valid(value)
  }

}
